// Romanian translations
export const ro = {
  // Navigation
  nav: {
    home: "Acasă",
    locations: "Locații",
    login: "Autentificare",
    profile: "Profil",
  },

  // Home page
  home: {
    newArrivals: "Noutăți",
    heroTitle: "Colecția de Vară 2025",
    heroSubtitle: "Descoperă produsele esențiale pentru sezon",
    exploreCollection: "Explorează Colecția",
    featuredProducts: "Produse Recomandate",
    viewAll: "Vezi Tot",
    findStore: "Găsește un Magazin",
    findStoreSubtitle: "Răsfoiește produsele disponibile în fiecare locație",
    viewLocations: "Vezi Locații",
  },

  // Locations page
  locations: {
    title: "Locațiile Noastre",
    subtitle: "Găsește produse disponibile în apropierea ta",
    viewProducts: "Vezi Produse",
  },

  // Products page
  products: {
    backToLocations: "Înapoi la Locații",
    allProducts: "Toate Produsele",
    availableProducts: "Produse Disponibile",
    filter: "Filtru:",
    all: "Toate",
    items: "produse",
    item: "produs",
    noProducts: "Nu există produse disponibile",
    noProductsHint: "Încearcă să selectezi o altă categorie",
    checkBackLater: "Revino mai târziu pentru actualizări",
    inStock: "în stoc",
    outOfStock: "Stoc Epuizat",
    sgrDeposit: "bani garanție",
    sgrInfo: "Garanție SGR: Acest produs include o garanție de {amount} bani care se returnează la reciclare.",
    currency: "lei",
  },

  // Auth page
  auth: {
    welcomeBack: "Bine ai Revenit",
    createAccount: "Creează Cont",
    signInSubtitle: "Conectează-te la contul tău",
    signUpSubtitle: "Alătură-te nouă și începe să explorezi",
    name: "Nume",
    namePlaceholder: "Numele tău",
    email: "Email",
    emailPlaceholder: "tu@exemplu.com",
    password: "Parolă",
    passwordPlaceholder: "••••••••",
    forgotPassword: "Ai uitat parola?",
    signIn: "Conectare",
    signUp: "Înregistrare",
    noAccount: "Nu ai cont?",
    hasAccount: "Ai deja cont?",
    pleaseWait: "Te rugăm așteaptă...",
  },

  // Profile page
  profile: {
    editProfile: "Editează Profil",
    save: "Salvează",
    cancel: "Anulează",
    signOut: "Deconectare",
    storeAuth: "Autentificare în Magazin",
    storeAuthSubtitle: "Scanează la magazinele Proximart pentru checkout rapid",
    showQrCode: "Arată acest cod QR la orice magazin Proximart",
    accountInfo: "Informații Cont",
    userId: "ID Utilizator",
    ageVerified: "Vârstă Verificată",
    yes: "Da",
    no: "Nu",
  },

  // Age verification
  ageVerification: {
    title: "Verificare Vârstă",
    verified: "Vârsta ta a fost verificată",
    notVerified: "Verifică-ți vârsta pentru a accesa toate funcțiile",
    verificationComplete: "Verificare Completă",
    verifiedAs18: "Ești verificat ca având 18+",
    startVerification: "Începe Verificarea Vârstei",
    checkStatus: "Verifică Statusul",
    checking: "Se verifică...",
    starting: "Se inițiază...",
    whatToExpect: "La ce să te aștepți:",
    step1: "Fă un selfie live folosind camera",
    step2: "AI verifică că ai 18 ani sau mai mult",
    step3: "Procesul durează mai puțin de 30 de secunde",
    poweredBy: "Oferit de Didit • Confidențialitatea ta este protejată",
    description: "Apasă butonul de mai jos pentru a începe procesul de verificare a vârstei. Vei fi redirecționat către partenerul nostru securizat de verificare unde vei face o fotografie live pentru a-ți verifica vârsta.",
  },

  // Forgot password
  forgotPasswordPage: {
    title: "Ai Uitat Parola?",
    subtitle: "Introdu email-ul și îți vom trimite un link de resetare",
    emailLabel: "Adresă Email",
    sendLink: "Trimite Link de Resetare",
    sending: "Se trimite...",
    backToLogin: "Înapoi la Autentificare",
    checkEmail: "Verifică-ți Email-ul",
    emailSent: "Dacă există un cont cu adresa {email}, vei primi un link de resetare a parolei în curând.",
  },

  // Reset password
  resetPassword: {
    title: "Resetează Parola",
    subtitle: "Introdu noua ta parolă mai jos",
    newPassword: "Parolă Nouă",
    confirmPassword: "Confirmă Parola",
    resetButton: "Resetează Parola",
    resetting: "Se resetează...",
    invalidLink: "Link de Resetare Invalid",
    invalidLinkDesc: "Acest link de resetare a parolei este invalid sau a expirat.",
    requestNewLink: "Solicită Link Nou",
    success: "Parolă Resetată!",
    successDesc: "Parola ta a fost resetată cu succes. Te poți conecta acum cu noua parolă.",
    goToLogin: "Mergi la Autentificare",
    passwordsDontMatch: "Parolele nu coincid",
    passwordTooShort: "Parola trebuie să aibă cel puțin 6 caractere",
  },

  // Common
  common: {
    loading: "Se încarcă...",
    error: "Eroare",
    success: "Succes",
    close: "Închide",
    noImage: "Fără Imagine",
  },

  // Toasts/Notifications
  toasts: {
    loginSuccess: "Bine ai revenit!",
    registerSuccess: "Cont creat! Te rugăm să îți verifici vârsta.",
    logoutSuccess: "Te-ai deconectat cu succes",
    profileUpdated: "Profil actualizat cu succes",
    verificationSuccess: "Verificare vârstă reușită!",
    verificationDeclined: "Verificarea vârstei a fost respinsă. Te rugăm să încerci din nou.",
    resetEmailSent: "Link de resetare trimis pe email",
    passwordResetSuccess: "Parolă resetată cu succes",
    authFailed: "Autentificare eșuată",
    errorOccurred: "A apărut o eroare",
  },
};

export default ro;
